import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export interface LoadingNotificationSnackbarData {
  message: string;
}

@Component({
  selector: 'app-loading-notification-snackbar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="loading-snackbar">
      <span class="loading-snackbar-spinner" aria-hidden="true"></span>
      <span class="loading-snackbar-message">{{ data.message }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .loading-snackbar {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      width: fit-content;
      min-height: 16px;
      max-width: min(100%, 640px);
      box-sizing: border-box;
    }

    .loading-snackbar-spinner {
      width: 12px;
      height: 12px;
      border: 1.5px solid rgba(255, 191, 0, 0.28);
      border-top-color: #ffc107;
      border-radius: 50%;
      flex-shrink: 0;
      animation: loading-snackbar-spin 0.9s linear infinite;
    }

    .loading-snackbar-message {
      min-width: 0;
      font-size: 14px;
      line-height: 1.2;
      font-weight: 500;
      word-break: break-word;
    }

    @keyframes loading-snackbar-spin {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }

    @media (max-width: 720px) {
      .loading-snackbar {
        width: 100%;
        max-width: 100%;
      }
    }
  `],
})
export class LoadingNotificationSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) readonly data: LoadingNotificationSnackbarData) {}
}
